import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-unauthorized',
    templateUrl: './unauthorized.component.html',
    standalone: false
})
export class UnauthorizedComponent implements OnInit {

  constructor() { }

  ngOnInit() {

  }

}
